import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "general__logout",
  "use": "general__logout-usage",
  "viewBox": "0 0 21 27",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 27\" id=\"general__logout\">\n  <path stroke-width=\"1.5\" d=\"m11.5 26.132 7.875-.077M11.5 1l7.875.054m0 24.683V1.395m-9.187 18.421 5.25-6.58m-5.25-6.578 5.25 6.579M1 13.237h14.438\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol